export const arChatbotTranslations = {

	chatbot: {
		title: 'مساعد القائمة',
		subtitle: 'اسألني أي شيء!',
		welcome: 'مرحباً!',
		welcomeMessage: 'أهلاً! أنا هنا لمساعدتك في استكشاف قائمتنا. ماذا تريد أن تعرف؟',
		inputPlaceholder: 'اسأل عن قائمتنا...',
		thinking: 'جارٍ التفكير',
		clearChat: 'مسح المحادثة',
		suggestedItems: 'موصى لك',
		hints: [
			'👋 أهلاً! أنا هنا لمساعدتك',
			'🍽️ اسألني عن قائمتنا!',
			'✨ تحتاج مساعدة في الاختيار؟',
			'🤖 مساعدك للطعام جاهز!',
			'🍕 ما الذي يبدو لذيذاً اليوم؟',
			'📋 دعني أساعدك في الطلب!',
			'🌟 اكتشف تخصصاتنا!',
			'🔍 ابحث في قائمتنا معي!'
		],
		quickActions: {
			viewMenu: 'عرض القائمة',
			vegetarianOptions: 'خيارات نباتية',
			popularDishes: 'الأطباق الشائعة',
			todaySpecial: 'طبق اليوم الخاص'
		},
		fetchingDatabase: "جاري جلب البيانات من قاعدة البيانات",
		processingRequest: "جاري معالجة طلبك",
		searchingMenu: "جاري البحث في عناصر القائمة",
		physicalKeyboardHint: "اضغط Enter للإرسال، Shift+Enter لسطر جديد",
		virtualKeyboardHint: "اضغط Enter لسطر جديد",
		inputPlaceholderPhysical: "اكتب رسالتك...",
		inputPlaceholderVirtual: "اكتب رسالتك...",
		minimize: 'تصغير',
		maximize: 'تكبير',
		close: 'إغلاق'
	}
};